import { FleetTaskPanel } from '@/components/fleet/fleet-task-panel';
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from '@/components/ui/drawer';
import type { ActiveLifecycleRun } from '@/hooks/use-lifecycle-action';

/**
 * Side panel for a destructive lifecycle run (decommission / quarantine /
 * recover). Opens when an action is triggered and lives until the operator
 * dismisses it — the task itself keeps running (and the pending overlay
 * stays) even if this panel is closed.
 */
export function LifecycleTaskPanel({
  activeRun,
  serverName,
  onDismiss,
}: {
  activeRun: ActiveLifecycleRun | null;
  serverName: string;
  onDismiss: () => void;
}): JSX.Element {
  return (
    <Drawer
      open={activeRun !== null}
      onOpenChange={(open) => {
        if (!open) onDismiss();
      }}
    >
      <DrawerContent aria-describedby="lifecycle-task-desc">
        {activeRun && (
          <>
            <DrawerHeader>
              <DrawerTitle>
                {activeRun.action.label} · task #{activeRun.taskId}
              </DrawerTitle>
              <DrawerDescription id="lifecycle-task-desc">
                {serverName} — live status from the Fleet API.
              </DrawerDescription>
            </DrawerHeader>
            <div className="overflow-y-auto">
              <FleetTaskPanel taskId={activeRun.taskId} />
            </div>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
}
